import { gql } from '@/__generated__';

const SIMULATE_USER = gql(`#graphql
  mutation SimulateUser($userId: Int!) {
    impersonateUser(userId: $userId) {
      id
      email
      name
      lastnames
      token
      organization_id

      phone
      callingCode
      phoneNumber
      role {
        id
        name
      }
      organization {
        id
        name
        photo
        access
      }
      organizations {
        id
        name
        photo
        access
        role {
          id
          name
        }
      }
      organizationsArray
      picture
      access {
        collections
        home
        controlCenter
        allDevices
        stations
        users
        collections
        virtualStations
        integrations
        dataAnalytics
        dataAdvanceAnalytics
        gates
        systems
        distribution
        dgaReports
        dataExtraction
        deviceConfiguration
        dataTables
        offLogin
        permits
        apiCapta
        distributionMaipo
        metricView
        deviceDiagnostics
        sendCommand
        channelNetwork
        audit
        standardDesign
        announcements
        notifications
        organizations
        billing
        alerts
        smaReports
        alertNotification
        viewAllocation
      }
      should_auth
      success
      message
      updatedPassword
      verify_auth
      status
    }
  }
`);

export default SIMULATE_USER;
